module.exports = __webpack_public_path__ + "media/images/badges/renewable-energy-100-a04c205bb83d4bf08dd89b3c936d7a28.svg";